<template>
    <div class="zb">
        <el-form :model="formData" ref="formRef" label-width="95px" size="mini">
            <div class="flex" >
                <el-form-item class="form-title" prop="title" label="标题" style="width: 590px">
                    <el-input  v-model="formData.title" clearable placeholder="请输入内容" size="mini" v-if="!edit" ></el-input>
                    <div  v-if="edit" class="mrA">{{formData.title}}</div>
                </el-form-item>
                <el-form-item class="form-title" prop="gsId" label="招标公司" required>
                    <div v-if="edit" style="width: 200px" class="mrA">{{formData.gsName}}</div>
                    <el-select style="width: 200px" v-model="formData.gsId" @change="pzsxChange('gs')"  filterable placeholder="请选择" size="mini" v-if="!edit">
                        <el-option
                                v-for="item in gsList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="i_gid" label="招标部门" required>
                    <div style="min-width: 200px" v-if="edit" class="mrA">{{formData.vc_gname}}</div>
                    <el-select style="width: 200px" size="mini" @change="pzsxChange('bm')" v-model="formData.i_gid" :placeholder="$t('form_please_select_department')"  filterable required v-else>
                        <el-option
                                v-for="itembm in groupName"
                                :key="itembm.i_id"
                                :label="itembm.vc_name"
                                :value="itembm.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="i_pztype" label="产品属性" required>
                    <div v-if="edit" style="width: 200px" class="mrA">{{formData.pztypeTxt}}</div>
                    <el-select style="width: 200px" @change="pzsxChange('pzsx')" v-model="formData.i_pztype" placeholder="产品属性"  filterable required v-else>
                        <el-option
                                v-for="itemsq in pzsxListData"
                                :key="itemsq.i_id"
                                :label="itemsq.vc_name"
                                :value="itemsq.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="payType" label="付款条件" required>
                    <div v-if="edit" style="width: 200px" class="mrA">{{formData.payType}}</div>
                    <el-radio-group v-model="formData.payType" v-if="!edit" style="width: 200px">
                        <el-radio   label="货到付款">货到付款</el-radio>
                        <el-radio   label="款到发货">款到发货</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="form-title" v-if="formData.payType=='货到付款'" prop="i_paydays" label="付款期限" required>
                    <el-input-number :controls="false" :precision="0"  v-model="formData.i_paydays" clearable style="width: 200px" placeholder="请输入付款期限" size="mini" v-if="!edit" :min="0"></el-input-number>
                    <div  v-if="edit" class="mrA" style="width: 200px">{{formData.i_paydays}}</div>
                </el-form-item>
                <el-form-item class="form-title" prop="vc_paytype" label="付款方式" required>
                    <div v-if="edit" style="width: 200px" class="mrA">{{formData.vc_paytype}}</div>
                    <el-radio-group v-model="formData.vc_paytype" v-if="!edit" style="width: 200px">
                        <el-radio   label="承兑">承兑</el-radio>
                        <el-radio   label="电汇">电汇</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="form-title" prop="type" label="收货方式" required>
                    <div v-if="edit" style="width: 200px" class="mrA">{{formData.type==1?'送货':'自提'}}</div>
                    <el-radio-group v-model="formData.type" style="width: 200px"  v-if="!edit">
                        <el-radio  :label='2'>自提</el-radio>
                        <el-radio  :label='1'>送货</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="form-title" prop="warehouseId" :label="$t('form_warehouse')" required v-if="formData.type==1" >
                    <div v-if="edit" style="width: 200px" class="mrA"> {{formData.warehouseName}}</div>
                    <el-select style="width: 200px" v-model="formData.warehouseId"  filterable placeholder="请选择" size="mini" v-if="!edit"  @change="changeck">
                        <el-option
                                v-for="item in ckList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="warehouseAddressName" label="仓库地址" v-if="formData.type==1" >
                    <div v-if="edit" style="width: 200px" class="mrA">{{formData.warehouseAddressName}}</div>
                    <el-select style="width: 200px" v-model="formData.warehouseAddressName" filterable clearable placeholder="请选择" size="mini" v-if="!edit" @focus="dict(5,formData.warehouseId)">
                        <el-option
                                v-for="item in ckaddList"
                                :key="item.id"
                                :label="item.location"
                                :value="item.location">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="duetime" label="截止日期" required>
                    <div v-if="edit && (!editDueTime || formData.state != 2 || editime != 1)" style="width: 200px" class="mrA">{{formData.duetime}}</div>
                    <el-date-picker
                            style="width: 200px;"
                            v-if="!edit || (formData.state == 2 && editime == 1 && editDueTime)"
                            v-model="formData.duetime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            size="mini"
                            default-time="23:59:59"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item class="form-title" prop="i_isdirect" label="定向招标" required>
                    <div v-if="edit" style="width: 200px" class="mrA">{{formData.i_isdirect==1?'是':'否'}}</div>
                    <el-radio-group style="width: 200px"  v-if="!edit" v-model="formData.i_isdirect">
                        <el-radio  :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="form-title" prop="i_isbargaining" label="是否议价" required>
                    <div v-if="edit" style="width: 200px" class="mrA">{{formData.i_isbargaining==1?'是':'否'}}</div>
                    <el-radio-group style="width: 200px"  v-if="!edit" v-model="formData.i_isbargaining">
                        <el-radio  :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="form-title" prop="directCompanys" label="定向供应商" required v-if="formData.i_isdirect==1">
                    <div v-if="formData.directCompanys&&formData.directCompanys.length>0"style="display: inline-block">
                        <span v-for="(com,index) in formData.directCompanys" :key="com.i_cid">
                            <template v-if="index==0">
                                <span style="color: #333">{{com.vc_cname}}</span>
                                <span v-if="formData.directCompanys.length>1">{{'(等共'+formData.directCompanys.length+'家公司)'}}</span>
<!--                                 <el-button type="text"  @click="$refs.popcom.show()">查看</el-button>-->
                            </template>
                        </span>
                        <el-popover ref="popcom" popper-class="popcom" width="300" trigger="click" v-if="formData.directCompanys.length>1&&edit">
                            <div v-for="(com,index) in formData.directCompanys" :key="com.i_cid">
                                <span>{{com.vc_cname}}</span>
                                <div style="margin-left: 24px" v-for="(file,index) in com.vc_files.otherfiles">
                                    <a style="font-size: 14px" :download="file.vc_name" mce_href="#"
                                       :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+file.vc_newname+',tenderapp\'}','utf-8')">
                                        {{file.vc_name}}
                                    </a>
                                </div>
                            </div>
                            <el-button type="text"  slot="reference" >查看</el-button>

                        </el-popover>

                    </div>
                    <el-button type="text"  @click="chooseGys"  v-if="!edit" >添加定向供应商</el-button>
                </el-form-item>
        </div>
            <el-table border
                      ref="sgtable1"
                      size="mini"
                      :row-style="rowstyle"
                      :data="formData.goods"
                      :height="tableHeight"
                      :header-cell-style="{background:'#eef1f6',color:'#000'}"
                      :highlight-current-row="true">
                <el-table-column  label="编号"  align="center"  prop="id" show-overflow-tooltip>  </el-table-column>
                <el-table-column  prop="pzName" label="品种" show-overflow-tooltip>
                </el-table-column>
                <el-table-column  prop="specification" label="规格" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="f_neednum"　label="需求总量">
                </el-table-column>
                <el-table-column prop="num"　label="本次招标量">
                </el-table-column>
                <el-table-column  prop="unit" label="单位"></el-table-column>
                <el-table-column  prop="vc_requires" label="需求说明">
                    <template slot-scope="scope">
                        <el-input style="width: 100%" v-model="scope.row.vc_requires" v-if="!edit" clearable size="mini" ></el-input>
                        <span v-else>{{scope.row.vc_requires}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="i_deliverydays"　label="要求交货周期(天)">
                    <template slot-scope="scope">
                        <el-input-number style="width: 100%" v-model="scope.row.i_deliverydays" v-if="!edit" :precision="0"  clearable size="mini" :controls="false" :min="1" ></el-input-number>
                        <span v-else>{{scope.row.i_deliverydays}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80" align="center">
                    <template slot="header" slot-scope="scope" v-if="!edit">
                        <el-button  icon="el-icon-plus"  @click="pzDetail"   size="mini" v-if="!edit" type="text" ></el-button>
                        <!--                            <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>-->
                    </template>
                    <template slot-scope="scope">
                        <el-button  icon="el-icon-minus" type="text"  v-if="!edit" @click="deletepz(scope.row,scope.$index)"  size="mini"></el-button>
                        <el-button  type="text"  @click="addSg(scope.row,scope.$index)"  size="mini" >编辑</el-button>

                    </template>
                </el-table-column>
            </el-table>
            <div>
                <span style="font-size: 12px;margin-left: 28px">请上传申购产品说明,规格补充说明等附件.(非必需)</span>
                <el-form-item class="form-title "  label="附件" style="margin-bottom: 5px;margin-left: -12px">
                    <template v-if="(!formData.vc_files||formData.vc_files.otherfiles.length==0)&&!edit">
                        <el-button  style="position: relative">上传附件<input type="file" name="files" value="" id="uploadfile"
                                              ref="uploadclear1"    class="upload-input uploadfile1" @change="uploadFile" ></el-button>

                    </template>
                    <template v-if="formData.vc_files&&formData.vc_files.otherfiles.length!=0">
                        <div v-for="(file,index) in formData.vc_files.otherfiles">
                            <a
                                    :download="file.vc_name"
                                    mce_href="#"
                                    :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+file.vc_newname+',tenderapp\'}','utf-8')">
                                <!--:herf="file"-->     {{file.vc_name}}
                            </a>
                            <el-button @click="clearFile(file,index)" v-if="!edit">删除附件</el-button>
                        </div>
                    </template>
                    <template v-if="formData.vc_files&&formData.vc_files.signfile">
                        <div v-if="formData.vc_files.signfile.vc_name">
                            <a
                                    :download="formData.vc_files.signfile.vc_name"
                                    mce_href="#"
                                    :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+formData.vc_files.signfile.vc_newname+',tenderapp\'}','utf-8')">
                                <!--:herf="file"-->     {{formData.vc_files.signfile.vc_name}}
                            </a>
<!--                            <el-button @click="clearFile(file,index)" v-if="!edit">删除附件</el-button>-->
                        </div>
                    </template>
                </el-form-item>
            </div>
            <div class="formDiv flex jcsb">
                <el-form-item class="form-title" prop="creatorName" :label="$t('form_creator')" >
                    <span>{{formData.creatorName}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="apply_date" label="制单日期" >
                    <span>{{formData.createTime}}</span>
                </el-form-item>
            </div>
        </el-form>

        <div  class="center">
            <template v-if="formData.state==0">
                <el-button type="primary" @click="save" :disabled="flow" :class="baseerp+'btn'" size="mini" v-if="!edit">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="editForm" :disabled="flow" :class="baseerp+'btn'" size="mini" v-if="edit">编辑</el-button>
                <el-button type="warning" @click="flowSub" :disabled="flow" size="mini" v-if="edit">提交审批</el-button>

            </template>
            <template v-if="formData.state==1">
                <el-button type="warning" @click="publishView" :disabled="flow" size="mini" v-if="edit">发布预览</el-button>
<!--                <el-button type="warning" @click="publish" :disabled="flow" size="mini" v-if="edit">发布</el-button>-->
            </template>
            <template v-if="formData.state==2&&editime == 1">
                <el-button  v-if="!editDueTime" type="primary"  @click="editDueTime = true"  :class="baseerp+'btn'" size="mini">编辑截止时间</el-button>
                <el-button  v-else type="primary" @click="savetime"  :class="baseerp+'btn'" size="mini">保存截止时间</el-button>
            </template>
            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
            <el-button class="marB10 hfc" @click="stop" :class="baseerp+'btn'" size="mini" v-if="tenderData.i_open_able==1&&tenderData.i_hasOpenRight==1&&formData.state==2" :disabled="flow">
                开标
            </el-button>
<!--            <el-button class="marB10" @click="save" :class="baseerp+'btn'" size="mini" :disabled="tableData.length==0||dissave" v-if="state==-1||state==0">-->
<!--                保存-->
<!--            </el-button>-->
<!--            <el-button class="marB10"  v-if="state==-1" @click="flowSub" :disabled="disup"  :class="baseerp+'btn'" size="mini">-->
<!--                提交审批-->
<!--            </el-button>-->
        </div>
    <!--        <div :class="baseerp+'div'">-->
        <el-dialog title="选择品种"
                   :class="baseerp+'div'"
                   width="90%"
                   :visible.sync="dialogTableVisible"
                   :close-on-click-modal="false"
                   :append-to-body="true">
            <pz-list :add="add" @close="closePz"  v-if="dialogTableVisible"></pz-list>
        </el-dialog>
        <el-dialog title="选择定向供应商"
                   :class="baseerp+'div'"
                   width="90%"
                   :visible.sync="dialogGysVisible"
                   :close-on-click-modal="false"
                   :append-to-body="true">
            <direct-com :gysData="gysData" @close="closeGys" v-if="dialogGysVisible"></direct-com>
        </el-dialog>
        <el-dialog title="发布"
                   :class="baseerp+'div'"
                   width="80%"
                   :visible.sync="dialogpublishView"
                   :close-on-click-modal="false"
                   :append-to-body="true">
            <publish-view :publishData="publishData" @close="closeFb" @refresh="refresh" v-if="dialogpublishView"></publish-view>
        </el-dialog>
        <el-dialog title="编辑"
                   :class="baseerp+'div'"
                   width="90%"
                   :visible.sync="dialogmxVisible"
                   :close-on-click-modal="false"
                   :append-to-body="true">
            <tender-list-info :data="mxData" @close="closeMx"  v-if="dialogmxVisible"></tender-list-info>
        </el-dialog>

<!--        </div>-->
    </div>
</template>

<script>
    import * as API from "../../api"
    import {mapActions} from "vuex";
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";
    import DirectCom from "./DirectCom";
    import PzList from "./TenderPzList";
    import PublishView from "./PublishView";
    import TenderListInfo from "./TenderListInfo";
    export default {
        name: "TenderList",
        components: { PzList,DirectCom,PublishView,TenderListInfo},
        props:{
            tenderData:{
                type:Object,
                required:true
            },
        },
        data() {
            return {
                formData:{
                    i_pztype:'',
                    gsId:'',
                    i_gid:'',
                    warehouseId:'',
                    warehouseAddressName:'',
                    payType:'货到付款',
                    vc_paytype:'承兑',
                    i_paydays:0,
                    type:1,
                    addTitle:'',
                    goods:[],
                    delgoods:[],
                    title:'',
                    status:'',
                    duetime:'',
                    directCompanys:[],
                    i_isdirect:0,
                    vc_files:{otherfiles:[],signfile:{},
                        i_isbargaining:0},

                },
                baseerp:'',
                token:'',
                i_uid:'',
                file_url: '',
                baseApp:"",
                baseVersion:"",
                search:'',
                pageSize:20,
                currentPage:1,
                tableTotal:0,
                highlightCurrentRow:true,
                tableHeight:0,
                pzList:[],
                ggList:[],
                ckList:[],
                gsList:[],
                groupName:[],
                pzsxListData:[],
                ckaddList:[{id:0,location:' '}],
                dialogTableVisible:false,
                dialogGysVisible:false,
                detailsVisible:false,
                dialogmxVisible:false,
                add:{},
                gysData:[],
                mid:0,
                edit:false,

                upid:0,
                index:0,
                seeck:false,
                fileId:0,
                dissave:false,
                disup:false,
                flow:false,
                zj:true,
                copyapplys:[],
                dialogpublishView:false,
                publishData:{},
                mxData:{},
                editime:0,
                editDueTime:false,
                nowtime:'',
            }
        },
        watch:{
            tenderData:{
                handler(){
                    this.mid = this.tenderData.i_mid;
                    this.id=this.tenderData.id;
                    this.editime=this.tenderData.i_hasChangeDeadlineRight
                    this.formData={
                        i_pztype:'',
                            gsId:'',
                            i_gid:'',
                            warehouseId:'',
                            warehouseAddressName:'',
                            payType:'货到付款',
                            vc_paytype:'承兑',
                            i_paydays:0,
                            type:1,
                            addTitle:'',
                            goods:[],
                        delgoods:[],
                            title:'',
                            status:'',
                        i_isdirect:0,
                        i_isbargaining:0,
                        directCompanys:[],
                        duetime:'',
                        vc_files:{otherfiles:[],signfile:{}},

                    };
                    // console.log(this.tenderDa    ta,'this.tenderData',this.id)
                    if(this.id==0){
                        this.edit = false
                        this.formData.id=this.tenderData.id;
                        this.formData.creatorName=sessionStorage.getItem("lruname");
                        this.formData.state=this.tenderData.state;
                        this.formData.applicant_name=sessionStorage.getItem("lruname");
                        this.formData.applicant_id=sessionStorage.getItem("userid");
                        this.formData.createTime=this.getDateYYYYMMddHHMMSS();
                        this.dict(2);
                        //this.dict(3);
                        this.getCompanyList()
                        this.pzsxList()
                    }else {
                        this.detail()
                        // if(this.state==0||this.state==-1) {
                        //     // console.log('1100')
                        //     this.edit = false
                        //     this.seeck = false
                        // }else{
                        //     this.edit=true
                        // }
                    }
                    this.nowtime=this.getDateYYYYMMddHHMMSS();
                    this.upid=this.tenderData.id;

                },
                immediate:true,
                deep:true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.token=sessionStorage.getItem("token");
            this.i_uid= sessionStorage.getItem("userid");
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.$nextTick(()=>{
                this.onResize();
            })

            /*if (!this.edit){

            }*/
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h*0.5
                if(this.tableHeight<60)this.tableHeight=60
            },
            rowstyle({row,column,rowIndex,columnIndex}){
                if(row.i_appid=='合计'){
                    return{backgroundColor:'#eef1f6'}
                }
            },
            cancel(){
                this.$emit('close')
            },
            async stopBid(){
                this.flow=true
                let param={
                    i_id:this.formData.id,
                };
                let res=await API.stopBid(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)

                    this.formData.state=4
                    this.flow=false
                    this.$emit('refresh')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                    this.flow=false
                }else{
                    this.$message.error(res.message);
                    this.flow=false
                }
            },
            stop(){
                this.$confirm('开标后将不能继续投标,是否继续开标','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    this.stopBid()
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
            pzDetail(val,index){
                if(this.formData.i_pztype){
                    this.dialogTableVisible=true;
                    this.index=index;
                    let applys=[];
                    this.formData.goods.map(g=>{
                        applys=[...applys,...g.applys]
                    })
                    this.add={
                        id:this.id,
                        vc_flags: this.formData.vc_flags,
                        i_pztype:this.formData.i_pztype,
                        applys:applys,
                        page:'goods'
                    }
                }else{
                    this.$message.warning('请选择产品属性')
                }
            },
            handelNum(num,pre=5){
                return Math.round(+num+'e'+pre)/Math.pow(10,pre)
            },
            closePz(type,pzitem,merge){
                this.dialogTableVisible=false;
                if(type=='save'){
                    let arr=this.formData.goods,hasharr=[];
                    if(!merge){
                        for (let item of pzitem){
                            let pz=item;
                            pz.f_num=item.f_reqnum;
                            let hash={
                                i_appid:pz.i_appid,
                                pzId:pz.i_pzid,
                                // num:sg.f_num,
                                pzPName:pz.pzPName,
                                pzName:pz.vc_pzname,
                                specification:pz.vc_bzstyle,
                                // f_addnum:sg.f_addnum,
                                unit:pz.vc_unit,
                                vc_requires:pz.vc_reqnote,
                                applys:[pz],
                                id:0,
                                f_addnum:0,
                                num:pz.f_reqnum,
                                f_neednum:pz.f_reqnum,
                            };
                            hasharr.push(hash)
                        }
                        for (let item of hasharr) {
                            let i=arr.findIndex(a=>a.i_appid==item.i_appid);
                            if (i==-1){
                                arr.unshift(item)
                            }else{
                                arr.splice(i,1)
                                arr.unshift(item)
                            }
                        }
                    }else{
                        let f_neednum=0;
                        pzitem.map(a=>{
                            f_neednum+=a.f_reqnum;
                            a.f_num=a.f_reqnum;
                        });
                        let hash={
                            i_appid:pzitem[0].i_appid,
                            pzId:pzitem[0].i_pzid,
                            // num:sg.f_num,
                            pzName:pzitem[0].vc_pzname,
                            pzPName:pzitem[0].pzPName,
                            specification:pzitem[0].vc_bzstyle,
                            // f_addnum:sg.f_addnum,
                            unit:pzitem[0].vc_unit,
                            vc_requires:pzitem[0].vc_reqnote,
                            applys:pzitem,
                            id:0,
                            f_addnum:0,
                            num:f_neednum,
                            f_neednum:f_neednum,
                        };
                        hasharr.push(hash)
                        for (let item of pzitem) {
                            let i=arr.findIndex(a=>a.i_appid==item.i_appid);
                            if (i==-1){
                                // arr.unshift(item)
                            }else{
                                arr.splice(i,1)
                                // arr.unshift(item)
                            }
                        }
                        arr=[...hasharr,...arr]
                    }

                    // arr=[...hasharr,...arr]
                     this.formData.goods=[...arr];
                }
                this.$forceUpdate();
            },
            deletepz(row,index){
                this.formData.goods.splice(index,1);
                if(row.id!=0)this.formData.delgoods.push(row.id);
                // this.getSum(row,index)
            },
            changeck(val){
                let obj=this.ckList.find(f=>f.id==this.formData.warehouseId);
                this.formData.warehouseName=obj.name
                this.formData.warehouseAddressName='';
                this.seeck=true;
                this.$forceUpdate();
            },
            chooseGys(){
                this.dialogGysVisible=true;
                this.gysData=this.formData.directCompanys||[]
            },
            closeGys(gys){
                this.dialogGysVisible=false;
                this.formData.directCompanys=gys;
            },
            addSg(row,index){
                this.chooserow=row;
                this.chooseIndex=index;
                this.dialogmxVisible=true;
                let pzapplys=[],goods=[];
                goods=JSON.parse(JSON.stringify(this.formData.goods));
                goods.splice(index,1);
                goods.map(g=>{
                    let arr=g.applys.filter(a=>a.i_pzid==row.applys[0].i_pzid)
                    pzapplys=[...pzapplys,...arr]
                })
                this.mxData={
                    applys:row.applys,
                    pzapplys:pzapplys,
                    edit:this.edit,
                    vc_flags: this.formData.vc_flags,
                    i_pztype:this.formData.i_pztype,
                }
            },
            closeMx(applys=[],delapplys=[]) {
                this.dialogmxVisible = false;
                if(applys.length>0){
                    this.formData.goods[this.chooseIndex].num = applys[applys.length - 1].f_num;
                    this.formData.goods[this.chooseIndex].f_neednum = applys[applys.length - 1].f_neednum;
                    this.formData.goods[this.chooseIndex].applys = applys.filter(a => a.i_appid != '合计');
                }
                if(delapplys.length>0){
                    this.formData.goods[this.chooseIndex].delapplys=[...delapplys,...this.formData.goods[this.chooseIndex].delapplys]

                }
            },
            cancelSg(row,index){
            },
            savetime(){
                this.DueTime()
            },
            async DueTime(){
                this.edit=true
                let param={
                    i_mid: this.mid,
                    i_id:this.id,
                    "duetime": this.formData.duetime,
                };
                let res=await API.changeDueTime(param);
                if ( res.code == 1 ){
                    this.editDueTime = false
                    this.$emit('refresh')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            editForm(){
                //console.log('2')
                this.edit=false;
                this.dict(2);
                //this.dict(3);
                this.getCompanyList()
                //this.getGroupList()
                this.pzsxList()
            },
            async detail(){
                this.edit=true
                let param={
                    i_mid: this.mid,
                    i_id:this.id,
                };
                let res=await API.bidsDetail(param);
                if ( res.code == 1 ){
                    this.formData=res.data;

                    this.$forceUpdate()
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async pzsxList(){
                let param={
                    // i_mid: this.mid,
                };
                let res=await API.pzsxList(param);
                if(res.code==1){
                    if (res.data.length>0){
                        this.pzsxListData=res.data;
                        let obj=this.pzsxListData.find(f=>f.i_id==this.formData.i_pztype);
                        if(obj)this.formData.vc_flags=obj.vc_flags
                        // this.$forceUpdate()
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let param={
                    i_mid: this.mid,
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    //console.log('1')
                    this.gsList = res.data;
                    if (this.id == 0) {
                        this.formData.gsId = res.data[0].i_id;
                        this.formData.gsName = res.data[0].vc_name;
                        this.getGroupList()
                    } else {
                        let obj = this.gsList.find(f => f.i_id == this.formData.gsId);
                        if (obj) this.formData.gsName = obj.vc_name
                    }

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getGroupList(){
                let param={
                    i_mid: this.mid,
                    i_gsid:this.formData.gsId,
                };
                let res=await API.getGroupList(param);
                if(res.code==1){
                    this.groupName=res.data;
                    if (res.data.length==1){
                        this.formData.i_gid=res.data[0].i_id;
                        this.formData.vc_gname=res.data[0].vc_name;
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            pzsxChange(type){
                if(type=='pzsx'){
                    // console.log(this.formData.i_pztype,'this.formData.i_pztypes')

                    if(this.formData.goods.length>0){
                        this.$confirm('更换产品属性会清空已经选择的产品列表,是否继续','提示',{
                            confirmButtonText:'继续',
                            cancelButtonText:'取消',
                            type:'warning'
                        }).then(()=>{
                            this.formData.goods=[];
                            let obj=this.pzsxListData.find(f=>f.i_id==this.formData.i_pztype);
                            this.formData.vc_flags=obj.vc_flags
                            this.formData.pztypeTxt=obj.vc_name
                            this.old_i_pztype=this.formData.i_pztype
                            this.$forceUpdate()
                        }).catch(()=>{
                            this.formData.i_pztype=this.old_i_pztype
                            let obj=this.pzsxListData.find(f=>f.i_id==this.formData.i_pztype);
                            this.formData.vc_flags=obj.vc_flags
                            this.formData.pztypeTxt=obj.vc_name
                            this.$message({
                                type:'info',
                                message:'已取消删除'
                            })
                        })
                    }else{
                        let obj=this.pzsxListData.find(f=>f.i_id==this.formData.i_pztype);
                        this.formData.vc_flags=obj.vc_flags
                        this.formData.pztypeTxt=obj.vc_name
                        this.old_i_pztype=this.formData.i_pztype
                        this.$forceUpdate()
                    }
                }else if(type=='gs'){
                    let obj=this.gsList.find(f=>f.i_id==this.formData.gsId);
                    this.formData.gsName=obj.vc_name;
                    // console.log(obj,'obj')
                    this.formData.i_gid='';
                    this.formData.vc_gname='';
                    this.getGroupList()
                }else if(type=='bm') {
                    let obj=this.groupName.find(f=>f.i_id==this.formData.i_gid);
                    this.formData.vc_gname=obj.vc_name;
                    this.$forceUpdate()
                }

            },
            async dict(type,pid=0){
                // console.log(resolve,'resolve',val)
               if(type==5&&pid==0&&!this.formData.warehouseId){
                    this.$message.error('请选择仓库');
                    return
                }
                let param={
                    i_mid: this.add.mid,
                    type:type,
                    i_pid:pid,
                    keyword:'',
                };
                let res=await API.dict(param);
                if ( res.code == 1 ){
                    if (res.data.list.length>0) {

                        if (type == 2) {
                            this.ckList = res.data.list;
                            if (this.id == 0||this.formData.warehouseId==0) {
                                this.formData.warehouseId = this.ckList[0].id
                                this.formData.warehouseName = this.ckList[0].name
                            } else {
                                let obj = this.ckList.find(f => f.id == this.formData.warehouseId);
                                if (obj) this.formData.warehouseName = obj.name
                            }
                        } else if (type == 3) {
                            this.gsList = res.data.list
                            if (this.id == 0) {
                                this.formData.gsId = this.gsList[0].id
                                this.formData.gsName = this.gsList[0].name
                            } else {
                                let obj = this.gsList.find(f => f.id == this.formData.gsId);
                                if (obj) this.formData.gsName = obj.name
                            }
                        } else if (type == 5) {
                            this.ckaddList = res.data.list
                            this.ckaddList.push({id: 0, location: ' '})
                        }
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async save(){
                let cans=true,cansday=true;
                if (this.formData.payType=='货到付款'&&(this.formData.i_paydays===''||this.formData.i_paydays==undefined)){
                    this.$message.error('请填写付款期限');
                    return
                }else if (this.formData.duetime==''){
                    this.$message.error('请填写截止日期');
                    return
                }else if (this.formData.gsId==0){
                    this.$message.error('请选择招标公司');
                    return
                }else if (this.formData.i_gid==''){
                    this.$message.error('请选择招标部门');
                    return
                }else if (this.formData.type==1&&this.formData.warehouseId==0){
                    this.$message.error('请选择仓库');
                    return
                }else if (this.formData.i_isdirect==1&&this.formData.directCompanys.length==0){
                    this.$message.error('请选择定向供应商');
                    return
                }else if(this.formData.goods.length==0){
                    this.$message.error('请选择产品');
                    return
                }else if(this.formData.goods.length>0){
                    for (let pz of this.formData.goods){
                        if(pz.num<=0){
                            cans=false
                            break
                        }
                        if(!pz.i_deliverydays){
                            cansday=false
                            break
                        }
                    }
                    if (!cans){
                        this.$message.error('请输入产品数量')
                        return
                    }
                    if (!cansday){
                        this.$message.error('请输入交货周期')
                        return
                    }
                }
                if (this.formData.type==2){
                    this.formData.warehouseId=null
                    this.formData.warehouseName=''
                    this.formData.warehouseAddressName=''
                }

                let form=JSON.parse(JSON.stringify(this.formData));
                // for (let i=0;i<this.copyapplys.length;i++){
                //     let copy =this.copyapplys[i];
                //     let obj=form.goods.findIndex(ap=>ap.i_appid==copy.i_appid);
                //     if(obj==-1&&copy.i_id!=0)form.delapplys.push(copy.i_id)
                // }
                this.flow=true
                let param=form;
                let res=await API.save(param);
                if ( res.code == 1 ){
                    this.flow=false
                    this.$message.success(res.message)
                    this.id=res.data
                    this.detail()
                    this.$emit('refresh')
                }else if (res.code == -2) {
                    this.flow=false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.flow=false
                    this.$message.error(res.message);
                }
            },
            publishView(){
                // this.flow=true
                this.dialogpublishView=true
                this.publishData={
                    id:this.id,
                }
            },
            closeFb(){
                this.dialogpublishView=false
            },
            refresh(){
                this.$emit('refresh')
                this.cancel()
            },
            async publish(){
                this.flow=true
                let param={
                    id:this.formData.id,
                    i_id:this.formData.id,
                    createTime:this.formData.createTime,
                    creatorTime:this.formData.creatorTime,
                    table:this.formData.table,
                    creatorId:this.formData.creatorId,
                    busType:this.formData.busType,
                    validateCode:this.formData.validateCode,
                    validateKeynames:this.formData.validateKeynames,
                };
                let res=await API.publish(param);
                if ( res.code == 1 ){
                    this.flow=false
                    this.$message.success(res.message);
                    this.$emit('refresh')
                    this.cancel()
                }else if (res.code == -2) {
                    this.flow=false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.flow=false
                    this.$message.error(res.message);
                }
            },
            async flowSub(item){
                this.flow=true
                this.$message.success('正在提交，请稍候')
                let param={
                    id:this.formData.id,
                    i_id:this.formData.id,
                    createTime:this.formData.createTime,
                    creatorTime:this.formData.creatorTime,
                    table:this.formData.table,
                    creatorId:this.formData.creatorId,
                    busType:this.formData.busType,
                    validateCode:this.formData.validateCode,
                    validateKeynames:this.formData.validateKeynames,
                };
                let res=await API.flowSub(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('refresh')
                    this.cancel()
                    this.flow=false
                }else if (res.code == -2) {
                    this.flow=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.flow=false
                    this.$message.error(res.message);
                }
            },
            addclose(){
                this.dialogTableVisible=false;
            },
            clearFile(val,index){
                this.formData.vc_files.otherfiles.splice(index,1)
                // this.formData.vc_files.otherfiles=[]
                this.$forceUpdate()
            },
            async uploadFile(e) {
                let that = this;
                let i = 0;
                let $files = e.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                // if(($files && result==false) || ($files &&result==undefined)){
                //     that.$message.error('请上传格式正确的文件');
                //     return;
                // };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "tenderapp",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "tenderapp",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname":  sessionStorage.getItem("lruname"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await API.uploadFile(param);
                    if (res.code == 1) {
                        // this.filesImgList.push(res.data[0])
                        // this.filesList.push(res.data[0].i_id)
                        let file={
                            i_id:res.data[0].i_id,
                            vc_name:res.data[0].filename,
                            vc_newname:res.data[0].filenewname,
                            vc_path:res.data[0].vc_path,
                            vc_app:'tenderapp'
                        }
                        this.formData.vc_files.otherfiles.push(file)
                        this.$forceUpdate()

                        // console.log(this.leaveList[index])
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .zb{
        position: relative;
    }
    .plusBtn{
        position: absolute;
        right: 0;
        top: 0px;
        height: fit-content;margin: 10px 0;
    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
    .flex{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
    .jcsb{
        justify-content: space-between;
    }
    .leftlabel{
        color: #000;
    }
    .mrt10{
        margin-top: 10px;
    }
    .mrl10{
        margin-left: 10px;
    }
    .mr10{
        margin-right: 10px;
    }
    .mrA{
        margin-top: auto;
        margin-bottom: auto;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .dfjc{
        display: flex;
        justify-content: space-between
    }
    .center{
        text-align: center;
    }
    .cell .el-button{
        padding: unset;
    }
    .el-button i{
        font-size: 18px;
        font-weight: bold;
    }
/deep/{
    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .el-dialog{
        min-width: 420px;
    }
    .el-input-number--mini{
        width: 80px;
    }
    .el-input-number.is-without-controls .el-input__inner{
        padding-left: 0px;
        padding-right: 0px;
    }
    .el-table__expand-icon{
        display: none;
    }
    .el-table__expanded-cell[class*=cell]{
        padding: 5px;
    }
    .el-radio{
        margin-right: 10px;
    }
    .el-dialog{

        margin:0 auto !important;
        margin-top: calc(7% - 40px) !important;
    }
    .el-button i{
        font-size: 18px;
        font-weight: bold;
    }
    .cell .el-button{
        padding: unset;
    }
    .el-form-item--mini.el-form-item{
        margin-bottom: 10px;
    }
}

</style>